// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"39809609","167":"a374d52d","211":"f9f6e9a7","403":"9fe61bf6","510":"e746d7cf","947":"462731b2"}[chunkId] + ".chunk.js";
};